import cx from 'classnames';
import { asset } from '../../services/assetResolverService';
import { Link } from '../link';
import { MainNavSearchBar } from './searchBar';
import { MainNavPremiumBlurb } from './siteLogo';
import { FC } from 'react';

type TSmallAuthBarLayoutProps = {
  toggleMenu: any;
  isMenuToggled: boolean;
  additionalColumnsComponent?: any;
};

export const SmallAuthBarLayout: FC<TSmallAuthBarLayoutProps> = (props) => {
  return (
    <>
      <div className="slds-grid slds-grid--vertical-align-center">
        <div className="slds-col slds-grow-none" onClick={props.toggleMenu}>
          <div className="burger-icon--container slds-p-around--small">
            <div className={cx('burger-icon', props.isMenuToggled ? 'is-active' : '')} />
          </div>
        </div>

        <div className="slds-col">
          <div className="slds-grid slds-grid--align-start slds-grid--vertical-align-center">
            <Link to="/">
              <img className="rio-topnav-menu-icon" src={asset('/images/brand/Mark_2ColorWhite.svg')} alt="" />
            </Link>
            <div className="slds-col">
              <MainNavPremiumBlurb />
            </div>
          </div>
        </div>

        {props.additionalColumnsComponent && (
          <div className="slds-col">
            <props.additionalColumnsComponent />
          </div>
        )}
      </div>
      <MainNavSearchBar />
    </>
  );
};
